import React from 'react';
import { StyledCheckbox, StyledError, StyledCheckboxLabel, Wrapper, } from './styles';
export const Checkbox = ({ errorMessage = '', id = '', label = '', onChangeValue = () => { }, state = '', value = '', name = '', checked = false, dataTest = '', }) => {
    return (React.createElement(Wrapper, null,
        React.createElement(StyledCheckboxLabel, { state: state },
            React.createElement(StyledCheckbox, { type: "checkbox", id: id, onChange: event => onChangeValue(event.target.checked), state: state, value: value, name: name, checked: checked, "data-test": dataTest }),
            label),
        errorMessage && React.createElement(StyledError, null, errorMessage)));
};
